import { render, staticRenderFns } from "./personalAuthentication.vue?vue&type=template&id=47bfeac9&scoped=true&"
import script from "./personalAuthentication.vue?vue&type=script&lang=js&"
export * from "./personalAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./personalAuthentication.vue?vue&type=style&index=0&id=47bfeac9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bfeac9",
  null
  
)

export default component.exports